import SCSettingReducer from 'store/search-console-setting/reducers';

export default SCSettingReducer;
